import {RemoteDataStore} from '../Cirrus/tlRemoteDataStore/tlRemoteDataStore';
import {defineCustomElements} from '@ionic/pwa-elements/loader';
import './vendor';
import * as angular from 'angular';
import {extendConfiguration} from '../config';
import {environment} from '../Environments/environment';

defineCustomElements(window);

console.log('load vendor');

const tlRemoteDataStoreModule = angular.module('tlRemoteDataStore', ['tlDataServices']);
tlRemoteDataStoreModule.service(RemoteDataStore.serviceId, RemoteDataStore);
const app = angular.module('app', [
  'tlDataServices',
  'ui.router',
  'ngCookies',
  'ngSanitize',
  'ngAnimate',
  'tlRemoteDataStore',
]);

extendConfiguration().then(() => {
  const {configs, constants, controllers, directives, factories, filters, services} = require('./app');
  for (const controller of controllers) {
    app.controller(controller.controllerId, controller);
  }

  for (const service of services) {
    app.service(service.serviceId, service);
  }

  for (const directive of directives) {
    app.directive(directive.name, directive.factory);
  }

  for (const config of configs) {
    app.config(config.inlineFn);
  }

  for (const constant of constants) {
    app.constant(constant.name, constant.value);
  }

  for (const factory of factories) {
    app.factory(factory.name, factory.fn);
  }

  for (const filter of filters) {
    app.filter(filter.name, filter.factory);
  }

  console.log('bootstrap app module');
  angular.bootstrap(document, ['app']);

});
